import { HttpMethod, Command } from "~/extensions/api";
export class FindInformationCommand extends Command {
    constructor() {
        super(HttpMethod.Post, "top/information");
    }
}
